<template>
  <div class="panel">
    <div class="headerPanel">
      <HeaderPanel />
    </div>
    <div class="navbarPanel">
      <NavbarPanel />
    </div>
    <div class="mainBooking">
      <Booking />
    </div>
  </div>
</template>

<script>
import HeaderPanel from "@/components/panel/HeaderPanel";
import NavbarPanel from "@/components/panel/NavbarPanel";
import Booking from "@/components/panel/booking/Booking";

export default {
  data() {
    return {
      linkDaPagina: null,
    };
  },
  async created() {
    this.linkDaPagina = window.location.href;
  },

  metaInfo() {
    return {
      title: "Booking de Informações | Leveros Integra",
      meta: [
        {
          name: "description",
          content:
            "Encontre de forma simples, todos os conteúdos de vendas, manual do usuário, procedimentos ADMS Lojas etc.",
        },
        { name: "robots", content: "noindex,nofollow" },
        { name: "country", content: "BRA" },
        { name: "currency", content: "R$" },
        { name: "author", content: "Leveros Integra" },
        { name: "copyright", content: "Leveros Integra" },
        {
          property: "og:title",
          content: "Booking de Informações | Leveros Integra",
        },
        {
          property: "og:description",
          content:
            "Encontre de forma simples, todos os conteúdos de vendas, manual do usuário, procedimentos ADMS Lojas etc.",
        },
        { property: "og:site_name", content: "Leveros Integra" },
        { property: "og:author", content: "Leveros Integra" },
        { property: "og:url", content: `${this.linkDaPagina}` },
        { property: "og:type", content: "company" },
      ],
      link: [{ rel: "canonical", href: `${this.linkDaPagina}` }],
    };
  },
  components: {
    HeaderPanel,
    NavbarPanel,
    Booking,
  },
};
</script>


<style lang="scss" scoped>
.panel {
  display: grid;
  grid-template-areas:
    "header header header"
    "main main main";
  grid-template-columns: 0.7fr 3fr;

  @media (max-width: 440px) {
    grid-template-areas:
      "header header header"
      "main main main";
  }
}

.headerPanel {
  grid-area: header;
}

.navbarPanel {
  grid-area: navbar;
}

.mainBooking {
  grid-area: main;
}
</style>